import { makeAutoObservable } from 'mobx';

export class ImpersonationMobxDto {
    email = '';

    constructor() {
        makeAutoObservable(this);
    }
}
